// Module
var code = "<h3>Outlines</h3> <ul class=\"slide-menu-items\"> <li class=\"slide-menu-item\"><a href=\"#/tran_def\">事务定义与特性</a></li> <li class=\"slide-menu-item\"><a href=\"#/concurrency\">事务并发控制</a></li> <li class=\"slide-menu-item\"><a href=\"#/recovery\">故障恢复</a></li> </ul> ";
// Exports
export default code;